const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';

import Photoleader from './contestants/Photoleader.jsx';
import Recentcontestantwidget from './contestants/Recentcontestantwidget.jsx';

//Import Designs
import { Container } from '@mui/material';

class Leaderwidgets extends Component {
    constructor(props) {
        super(props);
        this.state = { language: "en" };
    }

    render() {
        const shortatts = this.props;
        const widget = this.props.widget;
        return (
            <Container className="wpvc_photoleader_container">
                {widget == 'leader' &&
                    <Photoleader
                        short={shortatts.shortagrument}
                        SITE_URL={this.props.SITE_URL}
                    />
                }
                {widget == 'recent' &&
                    <Recentcontestantwidget
                        short={shortatts.shortagrument}
                        SITE_URL={this.props.SITE_URL}
                    />
                }
            </Container>
        )

    }
}

export default connect()(withTranslation("translations")(Leaderwidgets));
